module.exports = __webpack_public_path__ + "img/5.089d4f68.jpg";